import { ValidatorFn } from '@angular/forms';
import { INameId } from '@modeso/types__aumico-lib-core-be';
export interface IProperty {
    name: string;
    property: string;
    type?:
        | 'label'
        | 'text'
        | 'longtext'
        | 'date'
        | 'markup'
        | 'select'
        | 'switch'
        | 'checkbox'
        | 'radio'
        | 'translatable-markup'
        | 'translatable-text'
        | 'draggable-multi-select';
    action?: string;
    required?: boolean;
    options?: INameId[]; // Options for Select/Radio
    optionsLabel?: string; // For drop down menu label
    multiple?: boolean; // Multi select
    languages?: string[]; // For translatable fields
    disabled?: boolean;
    default?: string;
    extraValidators?: ValidatorFn[];
}
